import React from "react"
import CreateEditFunctionalGroupModal from "./CreateEditFunctionalGroupModal"


export default function FunctionalGroup({ functionalGroup, getFunctionalGroups, getFunctionalGroupDetails }) {
  return (
    <div>
      { functionalGroup.name }
      <CreateEditFunctionalGroupModal
        getFunctionalGroups={ getFunctionalGroups }
        mode="update"
        functionalGroup={ functionalGroup }
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/FunctionalGroup.js